import Details from './details';
import GroupCreate from './create';

export { GroupCreate };

export default Details;
